export default [
    {
        'text': '남자',
        'state': 'M'
    },
    {
        'text': '여자',
        'state': 'F'
    }
];



// WEBPACK FOOTER //
// ./src/api/gender.js